import { Flex, FlexProps, Box, BoxProps, Heading, Text, Link, HTMLChakraProps, Avatar } from '@chakra-ui/react';
import Image from 'next/image';
import NextLink from 'next/link';
import { FC, ReactNode } from 'react';

import { ThinProfile } from '@/resources/ThinProfile';

const wrapperStyles: FlexProps = {
  w: 'full',
  justify: 'start',
  alignItems: 'center',
  textAlign: 'left',
};

const infoContainerStyles: BoxProps = {
  minW: 0,
  flex: 1,
  pl: 4,
  alignSelf: 'stretch',
};

interface IExtendedProfileInfoProps extends HTMLChakraProps<'div'> {
  profile: ThinProfile;
  rightIcon?: ReactNode;
  contactItem?: ReactNode;
}

export const ExtendedProfileInfo: FC<IExtendedProfileInfoProps> = ({ profile, rightIcon, contactItem, ...rest }) => {
  return (
    <Flex {...wrapperStyles} alignItems="flex-start" {...rest}>
      <NextLink href={`/speakers/${profile.linkSlug}`}>
        {!profile?.mediumSquareAvatarUrl && (
          <Avatar bg="violet.500" color="white" size="2xl" name={profile?.fullName} />
        )}
        {profile?.mediumSquareAvatarUrl && (
          <Image
            style={{ borderRadius: '50%', height: '80px', width: '80px' }}
            src={profile?.mediumSquareAvatarUrl}
            alt={profile?.firstName}
            width={80}
            height={80}
          />
        )}
      </NextLink>
      <Box {...infoContainerStyles}>
        <NextLink href={`/speakers/${profile.linkSlug}`} passHref legacyBehavior>
          <Heading
            as={Link}
            noOfLines={2}
            fontSize="xl"
            lineHeight="base"
            whiteSpace="break-spaces"
            fontWeight="semibold"
            pb={1}
          >
            {profile?.fullName}
          </Heading>
        </NextLink>
        {profile.title && (
          <Text
            fontWeight="normal"
            fontSize="sm"
            lineHeight={4}
            color="gray.800"
            whiteSpace="break-spaces"
            noOfLines={2}
          >
            {profile.title}
          </Text>
        )}
        <Flex>{contactItem && contactItem}</Flex>
      </Box>
      {rightIcon}
    </Flex>
  );
};
